export default __webpack_public_path__ + "static/media/tree_grey.b0c064fa.svg";